/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
export class Driver {
  // driverDrivingLevel:{
  //   attachment: string;
  //   campusDrivingPermitNumber: string;
  //   driverDrivingLevelId: number;
  //   expirationDate: string;
  //   provingGroundLicenseNumber: string;
  //   siteId: number;
  //   trainingDate: string
  //   drivingLevel: {
  //     drivingLevelId:number;
  //     drivingLevelName:string;
  //     drscription: string;
  //   }
  // };
//   driverEndorsement: {
//   attachment:string;
//   dateValidated: string;
//   driverEndorsementId:number;
//   expirationDate:string;
//   siteId:number;
//   siteName:string;
//   endorsementDesc: string;
//   endorsementId:number;
//   endorsementName:string;
// };
  // driverTraining:{
  //   attachment:string;
  //   completeDate:string;
  //   driverTrainingId:number;
  //   expirationDate:string;
  //   siteId:number;
  //   // course:{
  //     courseName:string;
  //     courseNumber:string;
  //     trainingCourseId:number;
  //   // }
  // };
  driverID:number;
  comment:{};
  lastUpdatedDate:string;
  ratingScore:string;
  status_id:number;
  // gmpersonInfo:{
  badgeID: string;
  company: string;
  department: string;
  employeeTypeId: number;
  gmPersonID: number;
  namePrefix: string;
  identificationId: string;

  personID: number;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  //gmInfo: number;
  preferredName: string;
  accidentId: number;
  // };
  // violations:{
  //   attachment:string;
  //   pointsExpirationDate:string;
  //   referenceID:string;
  //   violationAra:string;
  //   violationComment:string;
  //   violationDate:string;
  //   violationId:number;
  //   violationPoints:number;
  //   violationTime:string;
  //   location:{
  //     active:boolean;
  //     locationId:number;
  //     locationName:string;
  //   }
  //   violationDefinition:{
  //     classification:string;
  //     description:string;
  //     points:number;
  //     type:string;
  //     violationDefinitionId:number;
  //   }
  // }
}
